export default __webpack_public_path__ + "static/media/Map-Design-White-Icon.b0869047.svg";